import React, { useState } from "react";

import FormInput from "../components/FormInput";
import "../styles/ReturnsAndExchanges.css";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

export default function ReturnsAndExchanges() {
  const [email, setEmail] = useState("");
  const [orderNumber, setOrderNumber] = useState("");
  const [requestType, setRequestType] = useState("return");

  const [foundItems, setFoundItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loadingOrder, setLoadingOrder] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validations
    if (!email || !orderNumber) {
      alert("Please enter both your email and order number.");
      return;
    }

    // Validate email format using a regular expression
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (!emailRegex.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    // Construct the payload.
    const payload = {
      email,
      orderNumber,
      requestType,
      itemsToReturn: foundItems.filter((item) =>
        selectedItems.includes(item.id)
      ),
    };

    setSubmitting(true);
    try {
      // Make POST request to the API endpoint for returns and exchanges
      const response = await fetch(`${apiUrl}/ct/returns-exchanges/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-App-Secret": process.env.REACT_APP_APP_SECRET,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to submit your request.");
      }

      await response.json();
      alert(
        "Your return/exchange request was submitted successfully. Please check your emails for more details"
      );

      setEmail("");
      setOrderNumber("");
      setFoundItems([]);
      setSelectedItems([]);
    } catch (error) {
      console.error("Error submitting return/exchange request:", error);
      alert(`An error occurred: ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  const lookupOrderDetails = async (orderNumber, email) => {
    const orderRegex = /^\d{8}-\d{12}$/;
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

    if (!orderRegex.test(orderNumber) || !emailRegex.test(email)) {
      setFoundItems([]);
      return;
    }

    setLoadingOrder(true);
    try {
      const response = await fetch(`${apiUrl}/ct/orders/lookup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-App-Secret": process.env.REACT_APP_APP_SECRET,
        },
        body: JSON.stringify({ orderNumber, email }),
      });

      if (!response.ok) {
        setFoundItems([]);
        return;
      }

      const data = await response.json();
      setFoundItems(data.items);
      setSelectedItems(data.items.map((item) => item.id)); // default to all selected
    } catch (err) {
      console.error("Lookup error:", err);
      setFoundItems([]);
    } finally {
      setLoadingOrder(false);
    }
  };

  return (
    <div className="return-exchange-container">
      <form onSubmit={handleSubmit} className="return-exchange-form">
        <h2>Do you wish to return or exchange your order?</h2>
        {/* <p className="required-fields">* Required fields</p> */}

        <FormInput
          label="Email"
          name="email"
          value={email}
          onChange={(e) => {
            const value = e.target.value;
            setEmail(value);
            lookupOrderDetails(orderNumber, value);
          }}
          rows={1}
          required
        />

        <FormInput
          label="Order Number"
          name="orderNumber"
          value={orderNumber}
          onChange={(e) => {
            const value = e.target.value;
            setOrderNumber(value);
            lookupOrderDetails(value, email);
          }}
          rows={1}
          required
        />

        {loadingOrder && <p>Looking up your order...</p>}

        {!loadingOrder && orderNumber && email && foundItems.length === 0 && (
          <p style={{ color: "red" }}>
            No items found for that order and email combination.
          </p>
        )}

        {foundItems.length > 0 && (
          <div className="product-selection">
            <h4>Select items to return:</h4>
            {foundItems.map((item) => (
              <div key={item.id}>
                <label>
                  <input
                    type="checkbox"
                    checked={selectedItems.includes(item.id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedItems([...selectedItems, item.id]);
                      } else {
                        setSelectedItems(
                          selectedItems.filter((id) => id !== item.id)
                        );
                      }
                    }}
                  />
                  {item.name} — Size {item.size} — Qty {item.quantity}
                </label>
              </div>
            ))}
          </div>
        )}

        <button
          type="submit"
          className="continue-button"
          disabled={
            foundItems.length === 0 || selectedItems.length === 0 || submitting
          }
        >
          {submitting ? "Submitting..." : "Continue"}
        </button>
      </form>
    </div>
  );
}
